import PropTypes from 'prop-types';
import classNames from 'classnames';

const FerryTypeSwitcher = ({ options, value, onChange }) => {
  const handleChange = (event) => {
    const index = Number(event.target.value);
    onChange(index);
  };
  if (options.length < 2) {
    return null;
  }
  return (
    <div>
      {options.map((item, index) => {
        const active = value === index;
        return (
          <label
            key={item.ferryTypeName}
            className={classNames('me-4 mt-2 pb-1', {
              'border-bottom border-3 border-accent': active,
            })}
          >
            <input
              className="d-none"
              type="radio"
              name="ferry_type"
              value={index}
              onChange={handleChange}
            />
            <span className="d-none d-xl-block text-large text-white">
              <i className={`${item.icon} pe-1`} />
              {item.ferryTypeName}
            </span>
            <span className="d-block d-xl-none text-white">
              <i className={`${item.icon} pe-1`} />
              {item.ferryTypeName}
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default FerryTypeSwitcher;

FerryTypeSwitcher.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      ferryTypeName: PropTypes.string,
      icon: PropTypes.string,
      segments: PropTypes.arrayOf(PropTypes.number),
    })
  ),
  onChange: PropTypes.func,
  value: PropTypes.number,
};
